<template>
    <v-sheet v-if="!(mode == 'view' && !items.length)">
        <div class="d-flex align-center" style="position: relative">
            <h5 class="page-text--lg mb-8 mb-lg-16 line-height-15">
                OA능력
                <!-- <span v-if="mode == 'form'" class="page-text--sm grey-6--text pl-8 font-weight-regular">OA능력 작성시 더 좋은 일자리를 구할 수 있습니다.</span> -->
            </h5>
        </div>

        <v-sheet>
            <v-divider class="primary border-2" />
            <v-data-table v-bind="{ items, headers }" :items-per-page="-1" hide-default-footer disable-sort disable-filtering :mobile-breakpoint="$vuetify.breakpoint.thresholds.sm">
                <template #[`item.name`]="{ item }">
                    <template v-if="mode == 'form'">
                        <v-row class="row--small">
                            <v-col :cols="$vuetify.breakpoint.mdAndUp ? 3 : 12">
                                <v-select v-model="item.type" :items="types" :menuProps="{ attach: `.item-type-${className}-${item.tempId.toString().slice(2)}` }" :class="`item-type-${className}-${item.tempId.toString().slice(2)}`" v-bind="attrs_input" @change="(type) => onChangeType(type, item)" />
                            </v-col>
                            <v-col :cols="$vuetify.breakpoint.mdAndUp ? 9 : 12">
                                <v-text-field v-model="item.name" :disabled="item?.type != OFFICE_SKILL_TYPES.ANOTHER.value" v-bind="attrs_input" @input="emit" />
                            </v-col>
                        </v-row>
                    </template>
                    <template v-else>
                        <p class="page-text grey--text">{{ getNameText(item) }}</p>
                    </template>
                </template>
                <template #[`item.score`]="{ item }">
                    <v-slider-reverse v-model="item.score" :tick-labels="['상', '중', '하']" step="50" :readonly="mode != 'form'" color="primary" trackColor="primary lighten-3" />
                </template>
                <template #[`item.actions`]="{ item }">
                    <v-btn icon x-small class="u-pink mx-auto" @click="remove(item)"><i class="icon icon-minus" /></v-btn>
                    <!-- <template v-if="$vuetify.breakpoint.mdAndUp">
                        <v-btn block text icon @click="remove(item)">
                            <v-icon large color="red lighten-4">mdi-minus-circle</v-icon>
                        </v-btn>
                    </template>
                    <template v-else>
                        <v-btn block color="red lighten-5" @click="remove(item)">
                            <v-icon large color="red lighten-4">mdi-minus-circle</v-icon>
                        </v-btn>
                    </template> -->
                </template>
                <template #footer>
                    <v-divider />
                    <template v-if="mode == 'form'">
                        <v-btn block color="grey-f8" class="v-btn--plus rounded-lg" @click="addItem"> <i class="icon icon-plus-sm" /> </v-btn>
                    </template>
                </template>
            </v-data-table>
        </v-sheet>
    </v-sheet>
</template>

<script>
import { attrs_input, initOfficeSkillItem, initResume, OFFICE_SKILL_TYPES } from "@/assets/variables";

import VSliderReverse from "@/components/plugins/vuetify/v-slider-reverse.vue";

const types = Object.values(OFFICE_SKILL_TYPES);

export default {
    components: {
        VSliderReverse,
    },
    props: {
        value: { type: Object, default: initResume }, // resume
        mode: { type: String, default: "form" },
    },
    data: () => ({
        resume: initResume(),

        types,
        attrs_input,
        OFFICE_SKILL_TYPES,
        className: Math.random().toString().slice(2),
    }),
    computed: {
        items() {
            return this.resume.officeSkills;
        },
        headers() {
            const headers = [];
            headers.push({ text: "OA 이름", value: "name" });
            headers.push({ width: 320, text: "횔용능력", value: "score" });
            if (this.mode == "form") headers.push({ width: +80, text: "", value: "actions" });
            return headers.map((item) => ({ ...item, align: item.align || "center", cellClass: `${item.cellClass || ""} pa-16` }));
        },
    },
    mounted() {
        this.sync();
    },
    watch: {
        value() {
            this.sync();
        },
    },
    methods: {
        sync() {
            this.resume = { ...initResume(this.value) };
        },
        emit() {
            let { officeSkills } = this.resume;
            this.$emit("input", { ...this.value, officeSkills });
        },
        addItem() {
            this.resume.officeSkills.push({ ...initOfficeSkillItem(), tempId: Math.random() });
            this.emit();
        },
        remove(item) {
            this.resume.officeSkills = this.resume.officeSkills.filter(({ tempId }) => tempId != item.tempId);
            this.emit();
        },
        onChangeType(type, item) {
            switch (type) {
                case OFFICE_SKILL_TYPES.ANOTHER.value: {
                    item.name = null;
                    break;
                }
                default: {
                    item.name = OFFICE_SKILL_TYPES[type]?.text;
                    break;
                }
            }
            this.emit();
        },
        getNameText({ type, name } = {}) {
            let text = OFFICE_SKILL_TYPES[type]?.text || "";
            if (type == OFFICE_SKILL_TYPES.ANOTHER.value) {
                if (text) text += " / ";
                text += name || "";
            }
            return text;
        },
    },
};
</script>

<style lang="scss" scoped>
::v-deep {
    .v-data-table__mobile-row {
        height: auto !important;
        display: block;
        border-bottom: 1px solid var(--border-color);
        padding: 10px !important;
    }
    .v-data-table__mobile-row__cell {
        width: 100%;
    }
    .v-data-table__mobile-row__header {
        margin-bottom: 6px;
    }
    .v-data-table__wrapper{
        overflow: visible;
    }
}
</style>